/**
 * ビジネスカテゴリー
 */
export const EnterpriseMatchingStatus = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  NONE: 'none',
  FORBIDDEN: 'forbidden',
} as const

export const EnterpriseMatchingStatusLabel: { [key: string]: string } = {
  [EnterpriseMatchingStatus.PENDING]: 'リクエスト中',
  [EnterpriseMatchingStatus.ACCEPTED]: 'マッチング済み',
  [EnterpriseMatchingStatus.REJECTED]: 'リクエスト拒否',
  [EnterpriseMatchingStatus.NONE]: '未リクエスト',
  [EnterpriseMatchingStatus.FORBIDDEN]: 'リクエスト不可',
}

export type EnterpriseMatchingStatusValue =
  (typeof EnterpriseMatchingStatus)[keyof typeof EnterpriseMatchingStatus]
